import * as React from "react";
const SvgFiRrPencilPaintbrush = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pencil-paintbrush_svg__a)">
      <path
        fill="#062147"
        d="M17.565 15.02c-2.496 0-4.527 2.018-4.527 4.5 0 2.575 2.646 4.5 5.013 4.5h3.49c.821 0 1.591-.388 2.057-1.035.44-.61.557-1.368.321-2.076-1.269-3.799-3.525-5.89-6.354-5.89m4.411 6.796a.53.53 0 0 1-.436.203h-3.489c-1.365 0-3.013-1.115-3.013-2.5s1.133-2.5 2.527-2.5c2.435 0 3.768 2.46 4.457 4.524a.28.28 0 0 1-.046.273m2.062-18.174c0-.969-.376-1.878-1.06-2.562-1.368-1.368-3.76-1.368-5.123 0L1.558 17.375a5.16 5.16 0 0 0-1.52 3.67v1.973a1 1 0 0 0 1 1h1.974c1.387 0 2.69-.54 3.67-1.52L22.98 6.203a3.6 3.6 0 0 0 1.06-2.562zM5.27 21.085a3.17 3.17 0 0 1-2.256.934H2.04v-.973c0-.852.332-1.654.934-2.256L15.32 6.444l2.295 2.295zM21.564 4.79l-2.537 2.537-2.295-2.295 2.538-2.538c.61-.61 1.682-.61 2.293 0 .305.307.475.714.475 1.15 0 .434-.168.841-.474 1.146M1.098 6.203A3.6 3.6 0 0 1 .04 3.643c0-.968.376-1.88 1.06-2.563 1.368-1.37 3.758-1.369 5.124 0l3.84 3.84a.999.999 0 1 1-1.415 1.413l-3.84-3.84c-.61-.612-1.683-.61-2.294 0a1.61 1.61 0 0 0-.475 1.15c0 .434.168.841.474 1.147l3.84 3.84a.999.999 0 1 1-1.415 1.413z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pencil-paintbrush_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPencilPaintbrush;
